'use client';

import { createContext, useContext } from 'react';
import type { ServerSessionResult } from '@/lib/auth/get-server-session';

const defaultSession: ServerSessionResult = {
  authenticated: false,
  roles: [],
};

const FrontSessionContext = createContext<ServerSessionResult>(defaultSession);

export function FrontSessionProvider({
  children,
  session,
}: {
  children: React.ReactNode;
  session: ServerSessionResult;
}) {
  return <FrontSessionContext.Provider value={session}>{children}</FrontSessionContext.Provider>;
}

export function useFrontSession(): ServerSessionResult {
  return useContext(FrontSessionContext);
}
